module.exports = "/packs/images/svg/ireland/facilities/camping~9ef091358e9c66f13dd38df5c70b7ce9.svg";